FairplayerImageVue(:url='url' :fallback-image='FairplayerFallbackImageUi.FAN' @load='onLoad')
